import React from "react";
import {
  parse,
  endOfMonth,
  format,
  startOfYear,
  endOfYear,
  subYears,
} from "date-fns";
import styles from "./style.module.scss";
import Button from "../../../../components/new-button";
import Filter from "../../../../assets/svg/icons/common/Filter";
import SettingsIcon from "../../../../assets/svg/icons/common/SettingsIcon";
import MonthPicker from "../../../../components/form/month-picker";
import useUserStore from "../../../../stores/user";
import useDashboardStore from "../../../../stores/dashboard";

const Header = () => {
  const user = useUserStore((state) => state.user);
  const setFilterDrawerOpen = useDashboardStore(
    (state) => state.setFilterDrawerOpen,
  );
  const filterCount = useDashboardStore((state) => state.getFilterCount());
  const setFilterData = useDashboardStore((state) => state.setFilterData);

  const handleMonthPickerChange = (data) => {
    let startDate, endDate;
    const currentDate = new Date();

    if (["YTD", "Current", "Last"].includes(data.month)) {
      if (data.month === "YTD") {
        startDate = startOfYear(currentDate);
        endDate = currentDate;
      } else if (data.month === "Current") {
        startDate = startOfYear(currentDate);
        endDate = endOfYear(currentDate);
      } else if (data.month === "Last") {
        const lastYearDate = subYears(currentDate, 1);
        startDate = startOfYear(lastYearDate);
        endDate = endOfYear(lastYearDate);
      }
    } else {
      const parsedDate = parse(
        `${data.month} ${data.year}`,
        "MMM yyyy",
        new Date(),
      );
      startDate = parsedDate;
      endDate = endOfMonth(parsedDate);
    }

    setFilterData({
      startDate: format(startDate, "MM/dd/yyyy"),
      endDate: format(endDate, "MM/dd/yyyy"),
    });
  };

  return (
    <div className={styles.headingContainer}>
      <div className={styles.headingLeft}>
        <h1 className={styles.headingLeftTitle}>
          Hello, {user?.name?.split(" ")[0]}
        </h1>
        <h5 className={styles.headingLeftSubtitle}>
          Here are your statistics for all your organizations and applications
        </h5>
      </div>

      <div className={styles.headingRight}>
        <MonthPicker
          variant="largeFilter"
          onSubmit={handleMonthPickerChange}
          changeOnSubmit
          showYearFilters
          showActions
        />

        <Button
          size="large"
          variant="secondary"
          condensedX
          onClick={() => setFilterDrawerOpen(true)}
        >
          <div className={styles.filterIconContainer}>
            <Filter width={24} className={styles.filterIcon} />
            {filterCount > 0 && (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  className={styles.filterEnabledDot}
                >
                  <path
                    d="M3.99992 6.83333C5.74882 6.83333 7.16658 5.41557 7.16658 3.66667C7.16658 1.91777 5.74882 0.5 3.99992 0.5C2.25102 0.5 0.833252 1.91777 0.833252 3.66667C0.833252 5.41557 2.25102 6.83333 3.99992 6.83333Z"
                    fill="#E03B24"
                    stroke="#EDEDF4"
                  />
                </svg>
                <span>{filterCount}</span>
              </>
            )}
          </div>
        </Button>

        <Button size="large" variant="ghost" condensedX>
          <SettingsIcon />
        </Button>
      </div>
    </div>
  );
};

export default Header;
